import { IJobTagGroup } from "../types/IJobTagGroup";

export class EntityJobTagGroup implements IJobTagGroup {
  constructor(public id: string, public title: string, public variant: string) {}

  static createFromObject(parameters: IJobTagGroup): EntityJobTagGroup {
    return new EntityJobTagGroup(parameters.id, parameters.title, parameters.variant);
  }
}
